module.exports = __webpack_public_path__ + "img/PrimaryOrigins.51bf705b.jpg";